// extracted by mini-css-extract-plugin
export default {"closeIcon":"WebAutoUploadModal__closeIcon--3XCLX","videoWrapper":"WebAutoUploadModal__videoWrapper--2Pbmu"};